// Speaker-Samples-API: laedt einen kurzen mp3-Ausschnitt pro Sprecher fuer den Wizard.

import getToken from '../auth/getToken';

const API = () => process.env.REACT_APP_BACKEND_URL;
const SCOPE = () => [`${process.env.REACT_APP_CLIENT_ID}/.default`];

export async function fetchSpeakerSample(instance, jobId, speakerId) {
  const token = await getToken(instance, SCOPE());
  if (!token) throw new Error('Keine gueltige Authentifizierung');
  const url = `${API()}/transcription_result/${encodeURIComponent(
    jobId,
  )}/speaker_sample/${encodeURIComponent(speakerId)}`;
  const res = await fetch(url, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) {
    let reason = `HTTP ${res.status}`;
    try {
      const data = await res.json();
      if (data?.error) reason = data.error;
    } catch (_) {
      // ignore
    }
    throw new Error(reason);
  }
  const blob = await res.blob();
  return URL.createObjectURL(blob);
}
